import { c as u, j as l } from "./createRuntimeFn-62c9670f.esm-CXdMsbWY.js";
import { vars as o } from "./theme.js";
/* empty css                              */
var r = u({ defaultClassName: "_3igy4n1", variantClassNames: { display: { true: "_3igy4n2" }, element: { h1: "_3igy4n3", h2: "_3igy4n4", h3: "_3igy4n5", h4: "_3igy4n6", h5: "_3igy4n7", h6: "_3igy4n8" }, noMargin: { true: "_3igy4n9" } }, defaultVariants: {}, compoundVariants: [] }), y = u({ defaultClassName: "_3igy4nb _3igy4na", variantClassNames: { noMargin: { true: "_3igy4nc" }, size: { l: "_3igy4nd", m: "_3igy4ne", s: "_3igy4nf", xs: "_3igy4ng" }, strong: { true: "_3igy4nh" }, underline: { true: "_3igy4ni" } }, defaultVariants: {}, compoundVariants: [] }), d = u({ defaultClassName: "_3igy4nj", variantClassNames: { italic: { true: "_3igy4nk" }, strong: { true: "_3igy4nl" }, underline: { true: "_3igy4nm" } }, defaultVariants: {}, compoundVariants: [] });
const t = (s, e) => {
  const n = {};
  return s && (n.dangerouslySetInnerHTML = { __html: s }), e && (n.style = { color: m(e) }), n;
}, m = (s) => {
  const e = o.colors.root.neutral[600], n = s == null ? void 0 : s.split(".");
  return n && n.reduce((i, c) => i[c], o.colors) || e;
}, N = ({ children: s, color: e, display: n, html: a, noMargin: i }) => /* @__PURE__ */ l.jsx(
  "h1",
  {
    className: r({ display: n, element: "h1", noMargin: i }),
    ...t(a, e),
    children: a ? null : s
  }
), p = ({ children: s, color: e, html: n, noMargin: a }) => /* @__PURE__ */ l.jsx(
  "h2",
  {
    className: r({ element: "h2", noMargin: a }),
    ...t(n, e),
    children: n ? null : s
  }
), x = ({ children: s, color: e, html: n, noMargin: a }) => /* @__PURE__ */ l.jsx(
  "h3",
  {
    className: r({ element: "h3", noMargin: a }),
    ...t(n, e),
    children: n ? null : s
  }
), j = ({ children: s, color: e, html: n, noMargin: a }) => /* @__PURE__ */ l.jsx(
  "h4",
  {
    className: r({ element: "h4", noMargin: a }),
    ...t(n, e),
    children: n ? null : s
  }
), H = ({ children: s, color: e, html: n, noMargin: a }) => /* @__PURE__ */ l.jsx(
  "h5",
  {
    className: r({ element: "h5", noMargin: a }),
    ...t(n, e),
    children: n ? null : s
  }
), v = ({ children: s, color: e, html: n, noMargin: a }) => /* @__PURE__ */ l.jsx(
  "h6",
  {
    className: r({ element: "h6", noMargin: a }),
    ...t(n, e),
    children: n ? null : s
  }
), C = ({
  children: s,
  color: e,
  html: n,
  size: a = "m",
  strong: i = !1,
  underline: c = !1,
  noMargin: g = !1
}) => /* @__PURE__ */ l.jsx(
  "p",
  {
    className: y({ noMargin: g, size: a, strong: i, underline: c }),
    ...t(n, e),
    children: n ? null : s
  }
), V = ({
  children: s,
  color: e,
  italic: n = !1,
  html: a,
  strong: i = !1,
  underline: c = !1
}) => /* @__PURE__ */ l.jsx(
  "span",
  {
    className: d({ italic: n, strong: i, underline: c }),
    ...t(a, e),
    children: a ? null : s
  }
);
export {
  C as B,
  N as H,
  V as I,
  p as a,
  x as b,
  j as c,
  H as d,
  v as e
};
//# sourceMappingURL=Typography-2ZjCxfuP.js.map
